import React from 'react';

import { Icon } from 'design-system-web';

import styles from './DragPreview.scss';

type Props = {
  name: string;
};

// A static stand-in for the dragged item. It fills the drag overlay, which the drag library
// sizes to the item's width before the drag. It never registers a scroll anchor, so the
// real item stays the only element the page can scroll to while the preview is on screen.
export function DragPreview({ name }: Props) {
  return (
    <div className={styles.preview} aria-hidden="true" data-test="drag-preview">
      <Icon name="grip-vertical" />
      <span>{name}</span>
    </div>
  );
}
